import {Component, Mixins, Watch} from "vue-property-decorator";
import OrganisationForm from "@/views/OrganisationsView/components/OrganistaionForm/OrganisationForm.vue";
import {mapActions, mapGetters} from "vuex";
import {PageMixin} from "@/mixins/pageMixin";
import {ActionTypes} from "@/vuex/modules/organisations-module/action-types";
import {OrganisationSearchParams} from "@/vuex/modules/organisations-module/actions";
import Organisation from "@/vuex/models/organisation/organisation";
import Meta from "@/vuex/models/meta";
import {OrganisationsSortableColumns} from "@/services/helpers/sort";
import UserForm from "@/views/UsersView/components/UserForm/UserForm";
import DeleteOrganisationModal from "@/views/OrganisationsView/components/DeleteOrganisationModal.vue";
import {Debounce} from "vue-debounce-decorator";

@Component({
    components: {
        DeleteOrganisationModal,
        UserForm,
        OrganisationForm
    },
    methods: mapActions({
        fetchOrganisations: ActionTypes.FETCH_ORGANISATIONS
    }),
    computed: mapGetters({
        organisations: 'organisations',
        meta: 'organisationsMeta'
    })
})
export default class OrganisationsView extends Mixins(PageMixin) {
    protected readonly fetchOrganisations!: (params: OrganisationSearchParams) => Promise<void>;

    protected readonly organisations!: Organisation[] | [];
    protected readonly meta!: Meta;
    protected readonly sortableColumns = OrganisationsSortableColumns;

    protected selectedOrganisation: Organisation | null = null;
    protected searchParams: OrganisationSearchParams = {
        page: 1,
        per_page: 25,
        direction: null,
        column: null,
        search: null,
        timezone: null,
        active: null,
        allow_to_join: null,
        manual_payment: null
    }

    protected async created(): Promise<void> {
        await this.paginate();
    }

    @Watch('searchParams', {deep: true})
    protected async paginate(): Promise<void> {
        this.loading = true;
        await this.fetchOrganisations(this.searchParams);
        this.loading = false;

        this.pagination = this.meta;
    }

    protected setPage(page: number): void {
        this.searchParams.page = page;
    }

    protected sortColumn(column: string): void {
        this.searchParams = this.sort(column, this.searchParams);
    }

    @Debounce(350)
    protected searchOrganisations(search: string): void {
        const params = this.search(search, this.searchParams);

        if (!!params) {
            this.searchParams = params;
        }
    }

    protected async closeForm(submitted: boolean): Promise<void> {
        this.showForm = false;
        this.selectedOrganisation = null;

        if (submitted) {
            await this.paginate();
        }
    }

    protected async closeModal(submitted: boolean): Promise<void> {
        this.showDeleteModal = false;
        this.selectedOrganisation = null;

        if (submitted) {
            await this.paginate();
        }
    }

    protected update(organisation: Organisation): void {
        this.showForm = true;
        this.selectedOrganisation = organisation;
    }

    protected remove(organisation: Organisation): void {
        this.showDeleteModal = true;
        this.selectedOrganisation = organisation;
    }
}
